"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale integrations Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.POFileProjectionKey = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.POFileProjectionKey = {
    Id: 'id',
    RejectionReason: 'rejectionReason',
    ShipFromAddress: 'shipFromAddress',
    ShipToAddress: 'shipToAddress',
    RelationId: 'relationId',
    SellerId: 'sellerId',
    Retailer: 'retailer',
    SpsPath: 'spsPath',
    SpsUrl: 'spsUrl',
    Status: 'status',
    S3Bucket: 's3Bucket',
    S3Key: 's3Key',
    TradingPartnerId: 'tradingPartnerId',
    PurchaseOrderNumber: 'purchaseOrderNumber',
    PurchaseOrderDate: 'purchaseOrderDate',
    DepositorOrderNumber: 'depositorOrderNumber',
    WholesaleOrderId: 'wholesaleOrderId',
    CustomerOrderNumber: 'customerOrderNumber',
    Items: 'items',
    Department: 'department',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    CancelDate: 'cancelDate',
    RequestedShipDate: 'requestedShipDate',
    RequestedDeliveryDate: 'requestedDeliveryDate',
    PoFileJsonMapperId: 'poFileJsonMapperId',
    SsccLabelTemplateId: 'ssccLabelTemplateId',
    PalletLabelTemplateId: 'palletLabelTemplateId',
    AsnSentAt: 'asnSentAt',
    IsTestOrder: 'isTestOrder',
    AsnS3Key: 'asnS3Key',
    AsnS3Bucket: 'asnS3Bucket',
    AckSentAt: 'ackSentAt',
    AckS3Bucket: 'ackS3Bucket',
    AckS3Key: 'ackS3Key',
    RawPurchaseOrderNumber: 'rawPurchaseOrderNumber',
    RawDepositorOrderNumber: 'rawDepositorOrderNumber',
    EdiChannel: 'ediChannel',
    BucketId: 'bucketId'
};
//# sourceMappingURL=pofile-projection-key.js.map